var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle } from 'reactstrap';
import DishHelper from './DishHelper';
import DishImage from './DishImage';
import DishLabel from './DishLabel';
import DishModal from './DishModal';
import DishPriceOption from './DishPriceOption';
import { getDiscountRuleText } from '../Restaurant/RestaurantDiscountLabel';
import DiscountIcon from '../../icons/DiscountIcon';
import OtoAlertNew from '../../components/common/OtoAlertNew';
import { ADDITIONAL_FIELD_TYPES } from '../../config';
import { isIframe } from '../../utils/url-params';
import DishAvailability from './DishAvailability';
import Shapes from 'Shapes';
import './dish.scss';
import { isAvailableNow } from 'App/models/dish';
var selectFieldTypes = [
    ADDITIONAL_FIELD_TYPES.MULTIPLE_CHOICE,
    ADDITIONAL_FIELD_TYPES.SINGLE_CHOICE,
];
var inIframe = isIframe();
var Dish = function (_a) {
    var _b, _c, _d;
    var addToCart = _a.addToCart, openImageModal = _a.openImageModal, dish = _a.dish, discountRule = _a.discountRule, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f;
    var _g = __read(useState(false), 2), modalOpen = _g[0], setModalOpen = _g[1];
    var toggleModal = function () { return setModalOpen(!modalOpen); };
    var cardClass = "dish ".concat(fullWidth ? 'dish--full-width' : '');
    var pricesWrapperClass = "dish__prices-wrapper ".concat(!!((_b = dish.priceOptions) === null || _b === void 0 ? void 0 : _b.length) ? 'dish__prices-wrapper--with-options' : '', " ").concat(dish.image ? 'dish__prices-wrapper--with-image' : '');
    var fieldsToSelect = (dish.additionalFields || []).filter(function (field) {
        return selectFieldTypes.includes(field.type);
    });
    var isAvailable = useMemo(function () { return isAvailableNow(dish); }, [dish]);
    return (React.createElement(Card, { className: cardClass },
        React.createElement("div", { className: "dish__content" },
            React.createElement("div", { className: "dish__text" },
                React.createElement(CardTitle, null,
                    dish.name,
                    dish.labels &&
                        dish.labels.map(function (lbl) { return (React.createElement(DishLabel, { key: lbl.value, label: lbl })); })),
                dish.desc && React.createElement("p", { className: "dish__desc" }, dish.desc),
                React.createElement(DishAvailability, { dish: dish }),
                discountRule && (React.createElement(OtoAlertNew, { color: "primary", className: "mt-2 d-inline-flex oto-alert--small", closable: false, icon: React.createElement(DiscountIcon, null), withBorder: true }, getDiscountRuleText(discountRule))),
                fieldsToSelect.length > 0 && (React.createElement("div", { className: "dish__select-fields-label" },
                    "Do wyboru: ",
                    fieldsToSelect.map(function (f) { return f.name; }).join(', ')))),
            !addToCart && dish.additionalFields && dish.additionalFields.length ? (React.createElement(React.Fragment, null, dish.additionalFields.map(function (field) { return (React.createElement("div", { className: "dish__additional-field dish__additional-field--onplace", key: field.name },
                React.createElement("strong", { className: "text-capitalize" },
                    field.name,
                    field.max && field.max > 1 ? " (maks. ".concat(field.max, ")") : '',
                    ":"),
                field.value,
                DishHelper.formatAddonPrice(field))); }))) : null,
            addToCart ? (React.createElement("div", { className: pricesWrapperClass },
                DishHelper.hasDifferentPrices(dish) ? (React.createElement("div", { className: "dish__price-prefix" }, "OD\u00A0")) : (''),
                React.createElement(DishPriceOption, { priceOption: !!((_c = dish.priceOptions) === null || _c === void 0 ? void 0 : _c.length) ? dish.priceOptions[0] : dish, single: true, showOldPrice: true }),
                React.createElement("button", { className: "btn btn-custom-outlined dish__add-to-cart-btn", disabled: isDisabled || !isAvailable, onClick: toggleModal }, "Dodaj"))) : !!((_d = dish.priceOptions) === null || _d === void 0 ? void 0 : _d.length) ? (React.createElement("div", { className: "d-flex flex-column align-items-start mt-2" }, dish.priceOptions.map(function (opt) { return (React.createElement(DishPriceOption, { key: opt.name, priceOption: opt, showName: true })); }))) : (React.createElement("div", { className: "dish__prices-wrapper align-self-start" },
                React.createElement("div", { className: "dish__price-prefix dish__price-prefix--onplace" }, "Cena:"),
                React.createElement(DishPriceOption, { priceOption: dish })))),
        dish.image && (React.createElement("div", { className: addToCart ? 'dish__img-container' : 'dish__img-banner', onClick: function () { return openImageModal(dish); } },
            React.createElement(DishImage, { dish: dish, inIframe: inIframe, isStatic: !addToCart }))),
        modalOpen ? (React.createElement(DishModal, { addToCart: addToCart, dish: dish, toggleModal: toggleModal })) : null));
};
Dish.displayName = 'Dish';
Dish.propTypes = {
    addToCart: PropTypes.func,
    dish: Shapes.restaurantMenuItemWithCategoryShape.isRequired,
    discountRule: PropTypes.object,
    isDisabled: PropTypes.bool,
    openImageModal: PropTypes.func.isRequired,
    fullWidth: PropTypes.bool,
};
export default React.memo(Dish);
